import { cssClasses } from 'pkg/css/utils';

import * as styles from './styles.css';

interface BackdropProps {
	animationDirection?: 'in' | 'out';
	zIndex?: number;
	className?: string;
}

export function Backdrop({
	animationDirection = 'in',
	zIndex,
	className,
}: BackdropProps) {
	return (
		<div
			className={cssClasses(
				styles.backdrop,
				animationDirection === 'in' ? styles.animatingIn : styles.animatingOut,
				className
			)}
			style={{
				zIndex: zIndex ? zIndex - 1 : undefined,
			}}
		/>
	);
}
